import DOMPurify from 'dompurify'

/** Sanitize HTML string — strips scripts, event handlers, etc. */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, { USE_PROFILES: { html: true } })
}
